import { z } from 'zod'

export const SubmitAdvisorRequestBody = z.object({
  email: z.string().trim().email('Enter a valid email'),
  firstName: z.string().trim().min(1, 'First name is required'),
  lastName: z.string().trim().min(1, 'Last name is required'),
  organizationName: z.string().trim().min(1, 'Organization name is required'),
  organizationWebsite: z.union([z.literal(''), z.string().trim().url('Enter a valid URL')]),
})

export const AdvisorRequestStatus = z.enum(['pending', 'approved', 'declined'])

export const AdvisorJoinRequest = z.object({
  id: z.string().uuid(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  organizationName: z.string(),
  organizationWebsite: z.string().nullable(),
  status: AdvisorRequestStatus,
  createdAt: z.string(),
})

export const AdvisorRequestIdBody = z.object({
  requestId: z.string().uuid(),
})

export type SubmitAdvisorRequestBodyType = z.infer<typeof SubmitAdvisorRequestBody>
export type AdvisorJoinRequestType = z.infer<typeof AdvisorJoinRequest>
